import React from 'react';
import { Tag, DatabaseTag } from '@fake-stack-overflow/shared/types/types';
import { Badge } from '../ui/badge';

interface TagsDisplayProps {
  tags: (Tag | DatabaseTag)[];
  onTagClick?: (tagName: string) => void;
  className?: string;
}

/**
 * TagsDisplay component for displaying tags in a consistent style across the application
 */
const TagsDisplay = ({ tags, onTagClick, className = '' }: TagsDisplayProps) => (
  <div className={`flex flex-wrap gap-2 ${className}`}>
    {tags.map((tag, index) => (
      <Badge
        key={'_id' in tag ? String(tag._id) : `tag-${index}`}
        variant='secondary'
        className='px-2 py-1 bg-primary/10 text-primary text-xs rounded-full cursor-pointer hover:bg-primary/20'
        onClick={e => {
          e.stopPropagation();
          if (onTagClick) {
            onTagClick(tag.name);
          }
        }}>
        {tag.name}
      </Badge>
    ))}
  </div>
);

export default TagsDisplay;
